import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Handshake } from "lucide-react";
import { API } from "@/config";
import { useAuth } from "@/context/AuthProvider";

export default function PartnerLogin() {
  const nav = useNavigate();
  const { login, logout } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (forgot) {
        await axios.post(`${API}/auth/forgot-password`, { email });
        toast.success("If that email belongs to a partner account, a reset link is on its way.");
        setForgot(false);
        return;
      }
      const u = await login(email, password);
      if (u.role !== "partner") { await logout(); toast.error("That account isn't a partner account."); return; }
      nav("/partners/dashboard", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Sign in failed.");
    } finally { setBusy(false); }
  };
  const cls = "w-full bg-black/30 border border-[#FFD166]/25 text-[#F6F1E4] px-3 py-2.5 rounded-lg focus:outline-none focus:border-[#FFD166]";
  return (
    <div className="min-h-screen bg-[#0F1E2C] text-[#F6F1E4] flex items-center justify-center px-4">
      <Helmet><title>Partner sign in — Enchanted Gear Rentals</title></Helmet>
      <form onSubmit={submit} className="glass max-w-md w-full p-8 md:p-10" data-testid="partner-login-form">
        <Handshake className="w-8 h-8 text-[#FFD166] mb-4" />
        <h1 className="font-serif text-3xl mb-1">{forgot ? "Reset your password" : "Partner sign in"}</h1>
        <p className="text-sm text-[#B9C8D5] mb-6">{forgot ? "We'll email you a secure link." : "Track your referral code, earnings and payouts."}</p>
        <label className="block mb-3"><span className="eyebrow block mb-1.5">Email</span><input type="email" className={cls} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="partner-login-email" /></label>
        {!forgot && <label className="block mb-5"><span className="eyebrow block mb-1.5">Password</span><input type="password" className={cls} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="partner-login-password" /></label>}
        <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="partner-login-submit">{busy ? "Please wait…" : forgot ? "Send reset link" : "Sign in"}</button>
        <div className="flex justify-between mt-4 text-xs text-[#B9C8D5]">
          <button type="button" onClick={() => setForgot(!forgot)} className="hover:text-[#FFD166]" data-testid="partner-login-forgot">{forgot ? "Back to sign in" : "Forgot password?"}</button>
          <Link to="/partners" className="hover:text-[#FFD166]">Apply to become a partner</Link>
        </div>
      </form>
    </div>
  );
}
